module.exports = __webpack_public_path__ + "static/media/cessione_credito.439721da.md";